import { render } from "./ReportFinanciadores.vue?vue&type=template&id=480b9666&scoped=true"
import script from "./ReportFinanciadores.vue?vue&type=script&lang=js"
export * from "./ReportFinanciadores.vue?vue&type=script&lang=js"

import "./ReportFinanciadores.vue?vue&type=style&index=0&id=480b9666&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480b9666"]])

export default __exports__